import React from "react";
import { DefaultInput } from "ui-kit-takeat";
import { ACTION_TYPES } from "./constants";
import { Select, Row2, FieldLabel } from "./styles";

// Editor de uma ação tipada (link / whatsapp / fechar), reusado no CTA da imagem
// e em cada botão do footer.
function ActionFields({ action, onChange, label = "Ação" }) {
  const update = (field, value) => onChange({ ...action, [field]: value });

  return (
    <div>
      <FieldLabel>{label}</FieldLabel>
      <Select
        value={action.type}
        onChange={(e) => update("type", e.target.value)}
      >
        {ACTION_TYPES.map((a) => (
          <option key={a.value} value={a.value}>
            {a.label}
          </option>
        ))}
      </Select>

      {action.type === "link" && (
        <div style={{ marginTop: 10 }}>
          <DefaultInput
            title="URL"
            value={action.url || ""}
            onChange={(e) => update("url", e.target.value)}
            placeholder="https://..."
          />
        </div>
      )}

      {action.type === "whatsapp" && (
        <Row2 style={{ marginTop: 10 }}>
          <DefaultInput
            title="Telefone (com DDI)"
            value={action.phone || ""}
            onChange={(e) => update("phone", e.target.value)}
            placeholder="5511999999999"
          />
          <DefaultInput
            title="Mensagem (opcional)"
            value={action.message || ""}
            onChange={(e) => update("message", e.target.value)}
            placeholder="Olá!"
          />
        </Row2>
      )}
    </div>
  );
}

export default ActionFields;
